<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-12 transparent-bg">
              <b-card-body id="login-form">
                <b-form>
                  <h1 class="text-light w-100 text-center">{{$t('enduser_register.title')}} <img class="navbar-brand-full" src="img/innoknight/logo.png" width="37" height="48" alt="InnoKnight"></h1>
                  <p class="text-light">{{$t('enduser_register.description')}}</p>

                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-at"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_register.email_placeholder')" 
                                  v-model.lazy.trim="$v.username.$model"
                                  v-focus
                                  :state="chkState('username')"
                                  aria-describedby="invalidEmailFeedback"/>
                    <b-form-invalid-feedback id="invalidEmailFeedback">{{$t('enduser_register.invalidEmailFeedback')}}</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_register.password_placeholder')" 
                                  v-model.lazy.trim="$v.password.$model"
                                  :state="chkState('password')"
                                  aria-describedby="invalidPasswordFeedback"/>
                    <b-form-invalid-feedback id="invalidPasswordFeedback">{{$t('enduser_register.invalidPasswordFeedback', { min: $v.password.$params.minLength.min})}}</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_register.repeat_password_placeholder')"
                                  v-model.lazy.trim="$v.repeatPassword.$model"
                                  :state="chkState('repeatPassword')"
                                  aria-describedby="invalidPassword2Feedback"/>
                    <b-form-invalid-feedback id="invalidPassword2Feedback">{{$t('enduser_register.invalidPassword2Feedback')}}</b-form-invalid-feedback>
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-address-book-o"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_register.name_placeholder')"
                                  v-model.lazy.trim="$v.name.$model"
                                  :state="chkState('name')"
                                  aria-describedby="invalidNameFeedback"/>
                    <b-form-invalid-feedback id="invalidNameFeedback">{{$t('enduser_register.invalidNameFeedback')}}</b-form-invalid-feedback>
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-phone"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="tel" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_register.phone_placeholder')"
                                  v-model.lazy.trim="$v.phone.$model"
                                  :state="chkState('phone')"
                                  aria-describedby="invalidPhoneFeedback"
                                  maxLength="10"/>
                    <b-form-invalid-feedback id="invalidPhoneFeedback">{{$t('enduser_register.invalidPhoneFeedback')}}</b-form-invalid-feedback>
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-grav"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_register.token_placeholder')"
                                  v-model.lazy.trim="$v.token.$model"
                                  :state="chkState('token')"
                                  aria-describedby="invalidTokenFeedback"/>
                    <b-form-invalid-feedback id="invalidTokenFeedback">{{$t('enduser_register.invalidTokenFeedback')}}</b-form-invalid-feedback>
                    <b-button variant="success" :disabled="!($v.username.email&&$v.username.required)||!($v.phone.cellphone&&$v.phone.required)" class="px-4" @click="getToken()">{{$t('enduser_register.getToken')}}</b-button>
                    <span class="d-inline-block w-100 text-warning" v-if="is_get_token_clicked">{{$t('enduser_register.getTokenRemarks')}}</span>
                  </b-input-group>

                  <b-row>
                    <b-col cols="12">
                      <b-button variant="primary" :disabled="!$v.token.required||register_processing" class="px-4 w-100" @click="submit()">{{$t('enduser_register.submit')}}</b-button>
                      <span class="text-center d-inline-block w-100 text-warning" v-if="register_processing">{{$t('enduser_register.register_processing')}}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="text-center text-light" style="padding-top:1.2rem;">
                      <h5 class="d-inline pointer" @click="gotoLogin()">{{$t('enduser_register.is_account_exist')}}<i class="fa fa-sign-in"></i> {{$t('enduser_register.gotoLogin')}} &nbsp;&nbsp;</h5>
                      <h5 v-if="false" class="d-inline pointer" @click="gotoResetPassword()"><i class="fa fa-key"></i> {{$t('enduser_register.gotoResetPassword')}} </h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="mt-3 ml-auto text-white pri-info-declaration text-center">
                        <span v-html="PrivacyPolicy"></span> 
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="ml-auto text-white pri-info-declaration text-center">
                        {{$t('innoknight') + '©' + thisyear}}
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength, between, email, sameAs, maxLength } from 'vuelidate/lib/validators'
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'

const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const api_root = config.api_root;

let getUrlParameter = function getUrlParameter(url) {
    var sPageURL = url.substring(url.indexOf('?')+1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i,
        rlt={};


    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        rlt[sParameterName[0]] = sParameterName[1];
    }

    return rlt;
};//eo getUrlParameter

const cellphone = (value) => {
  const phoneRegex = /^09\d{8}$/;
  return phoneRegex.test(value || '') ;
};

const generateRandomToken = () => {
  // 使用 36 進位，並串接兩個隨機數來增加長度
  const part1 = Math.random().toString(36).slice(2).toUpperCase();
  const part2 = Math.random().toString(36).slice(2).toUpperCase();
  const part3 = Math.random().toString(36).slice(2).toUpperCase();
  return `${part1}${part2}${part3}`; 
};

export default {
  name: 'Login',
  
  notifications,

  beforeMount() {
    let app = this;

    if(location.hash){
      let get_params = getUrlParameter(location.hash);

      if(!get_params.ccid){
        return;
      }

      let params = {
        ccid: get_params.ccid
      };

      // this.$state.$set('ccid', decodeURIComponent(get_params.ccid));

      if(get_params && get_params.ccid){
        let action = `${config.admin_root}/get_company`;
        fetch(action, {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + generateRandomToken()
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(result && result.company && result.company.name){
            app.ccff = config.decrypt(decodeURIComponent(get_params.ccid), config.ffkey, config.ffiv);
          } else {
            showError({message: app.$t('enduser_register.error.incorrect_company_link')});
          }
        }).catch(error => {
          showError({message: app.$t('enduser_register.error.incorrect_company_link')});
        });
      }
    }
  },//eo beforeMount

  data() {
    const this_year = new Date();

    return {
      ccff:                 null,
      username:             '',
      password:             '',
      repeatPassword:       '',
      name:                 '',
      phone:                '',
      token:                '',
      captcha_action:       '',
      show_capthca:         config.show_capthca,
      captcha_action:       config.captcha_action,
      submit_btn_disabled:  true,
      is_get_token_clicked: false,
      thisyear: this_year.getFullYear(),
      footer: config.footer,
      register_processing: false
    };
  },//eo data

  computed: {
    PrivacyPolicy() {
      const link = `<a href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021" target="_blank">${this.$t('personal_data_protection_act')}</a>`;
      return this.$t('privacy_policy_message', { link });
    }
  },//eo computed

  methods: {
    submit(){
      // console.info('submit');return;
      
      let app = this;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showError({message:this.$t('enduser_register.error.incorrect_input'), timeout: 15000});
        return false;
      }

      grecaptcha.execute(config.captcha_key, {action: 'registerform'})
      .then(function(ggtoken) {

        let username = app.username;
        let password = app.password;
        let phone    = app.phone;
        let name     = app.name;
        let token    = app.token;
        let ccff     = app.ccff;

        // console.info('ccff:', ccff);return;
        app.register_processing = true;
        let action = `${api_root}/enduser/register`;
        let params   = {
          keyset: 'mqtt',
          form: encodeURIComponent(encrypt(JSON.stringify({
            username,
            password,
            phone,
            name,
            token,
            ccff
          }))),
          frontend:location.origin,
          ggtoken
        };
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + generateRandomToken()
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(!result.success){
            app.showError({
              message: result.message, //TODO: i18n
              timeout: 15000
            });
          } else {
            app.showSuccess({
              message: result.message, //TODO: i18n
              timeout: 5000
            });
            app.$router.push('/');
          }
          app.register_processing = false;
        }).catch(error => {
        });
      });
    },//eo submit
    chkState(val) {
      const field = this.$v[val];
      return !field.$dirty || !field.$invalid;
    },//eo chkState
    gotoLogin() {
      this.$router.push('/');
    },//eo gotoLogin
    gotoResetPassword(){
      this.$router.push('/amnesia');
    },//eo gotoResetPassword
    getToken(){
      let app = this;

      if(app.is_get_token_clicked){
        app.showWarn({
          message: this.$t('enduser_register.warning.wait_token_get')
        });
        return false;
      }

      app.is_get_token_clicked = true;

      let _cc = setTimeout(() => {
        app.is_get_token_clicked = false;
      }, 30000);

      grecaptcha.execute(config.captcha_key, {action: 'register'})
      .then(function(ggtoken) {

        let username = app.username;
        let phone = app.phone;
        let action   = `${api_root}/enduser/register_send_token`;
        let params   = {
          keyset: 'mqtt',
          username: encodeURIComponent(encrypt(JSON.stringify({username}))),
          phone: encodeURIComponent(encrypt(JSON.stringify({phone}))),
          ggtoken
        };

        // console.info(`params: `, params);

        // alert(`params.phone: ${app.phone}`);
        fetch(action, {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + generateRandomToken()
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(!result.success){
            if(result.message === 'MAIL_USED'){
              app.showWarn({
                message: app.$t('enduser_register.warning.email_used', { username }),
                timeout: 15000
              });
            } else if(result.message === 'PHONE_USED'){
              app.showWarn({
                message: app.$t('enduser_register.warning.phone_used', { phone }),
                timeout: 15000
              });
            } else if(result.message === 'RECAPTCHA_FAIL'){
              app.showError({
                message: app.$t('enduser_register.error.recaptcha_fail'),
                timeout: 15000
              });
            } else {
              app.showError({
                message: app.$t('enduser_register.error.token_others_error'),
                timeout: 15000
              });
            }
            clearTimeout(_cc);
            app.is_get_token_clicked = false;
          } else {
            app.showSuccess({
              message: app.$t('enduser_register.token_sent', { username }),
              timeout: 15000
            });
          }
        }).catch(error => {
        });
      });

    },//eo getToken
  },//eo methods

  validations: {
    username: {
      email,
      required,
      minLength: minLength(5)
    },
    password: {
      required,
      minLength: minLength(5),
    },
    repeatPassword: {
      required,
      minLength: minLength(5),
      sameAs: sameAs('password')
    },
    name: {
      required,
      minLength: minLength(2)
    },
    phone: {
      cellphone,
      required,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
    token: {
      required,
      minLength: minLength(6)
    },
  }//eo validations
}
</script>

<style>
.card-body{
  padding: 1.25rem !important;
}
.pointer{
  cursor: pointer;
}
.grecaptcha-badge{
  display: none;
}
.app{
  background: black;
}
.login-form{
  margin-top: 4rem;
}
</style>
  